import { useRef } from 'react';
import { useApp } from '../AppContext';
import './InviteModal.css';

export default function InviteModal() {
  const { user, showToast } = useApp();
  const overlayRef = useRef();

  const link = user ? `mercyapp.vercel.app/join/${user.inviteCode}` : 'mercyapp.vercel.app/join/...';

  function close(e) {
    if (e.target === overlayRef.current) {
      overlayRef.current.classList.remove('visible');
    }
  }

  function copyLink() {
    navigator.clipboard.writeText(`https://${link}`).catch(() => {});
    showToast('Link copied');
  }

  function shareLink() {
    const text = `Join me on Mercy — forgive everyone before we sleep. https://${link}`;
    if (navigator.share) {
      navigator.share({ title: 'Mercy', text, url: `https://${link}` });
    } else {
      window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
    }
    overlayRef.current?.classList.remove('visible');
  }

  return (
    <div id="invite-modal" className="modal-overlay" ref={overlayRef} onClick={close}>
      <div className="modal-sheet">
        <div className="modal-handle" />
        <h2 className="modal-title">Invite to Mercy</h2>
        <p className="modal-sub">
          Share your link. When someone signs up through it, you'll automatically be connected.
        </p>
        <div className="invite-link-box">
          <span className="invite-link-text">{link}</span>
          <button className="copy-btn" onClick={copyLink}>Copy</button>
        </div>
        <button className="btn btn-primary" onClick={shareLink}>Share via WhatsApp / SMS</button>
      </div>
    </div>
  );
}
